export default "__VITE_ASSET__3f7d956b__"